import useAIChat from '@/composables/ai-chat/ai-chat';
import useLocalStorage from '@/composables/local-storage/local-storage';
import useLoggedInUserAccount from '@/composables/logged-in-user-account/logged-in-user-account';
import { DEFAULT_WIDTH_AI_CHAT_PANEL } from '@/lib/constants';
import { computed, ref } from 'vue';

const defaultState = () => ({ open: false, activeChatId: null, width: DEFAULT_WIDTH_AI_CHAT_PANEL });

const sharedState = new Map();

const stateForKey = (key) => {
  if (!sharedState.has(key)) {
    const { data } = useLocalStorage(localStorage, { getKey: () => ref(key) }, defaultState());
    sharedState.set(key, data);
  }
  return sharedState.get(key);
};

export const resetSharedState = () => sharedState.clear();

export default function useAiChatPanel() {
  const { loggedInUserAccount } = useLoggedInUserAccount();
  const { canUseAIChat } = useAIChat();
  const key = computed(() => `${loggedInUserAccount.value?.uid}_ai-chat_panel`);

  const state = () => stateForKey(key.value);
  const patch = (values) => {
    const data = state();
    data.value = { ...defaultState(), ...data.value, ...values };
  };

  const open = computed(() => canUseAIChat.value && state().value.open === true);
  const activeChatId = computed(() => {
    const { activeChatId: id } = state().value;
    return id === undefined ? null : id;
  });
  const width = computed(() => state().value.width ?? DEFAULT_WIDTH_AI_CHAT_PANEL);

  const close = () => patch({ open: false });
  const toggle = () => patch({ open: !open.value });
  const openChat = (uid) => patch({ open: true, activeChatId: uid });
  const newChat = () => patch({ open: true, activeChatId: null });
  const setWidth = (value) => patch({ width: value });

  return {
    open,
    activeChatId,
    width,
    close,
    toggle,
    openChat,
    newChat,
    setWidth,
  };
}
